import React from "react";

export default function Price({ isAvailable, price }) {
    return (
        <div
            className={`rounded-full px-4 py-2 text-sm font-semibold text-center min-w-[80px]
                ${isAvailable ? "bg-white text-black" : "bg-red-600 text-white"}`}
        >
            {isAvailable ? price : "N.D."}
        </div>
    );
}
